import React from "react";
import { connect } from "react-redux";
import { removeAlert } from "../../actions/alert";
import { StickyDiv } from "../../styles/styled-components-utils";

const Alert = ({ alerts, removeAlert }) => {
  // Don't render anything if there are no alerts
  if (!alerts || alerts.length === 0) {
    return null;
  }

  return (
    <StickyDiv>
      <div className="alert-container">
        {alerts.map((alert, index) => (
          <div
            key={index}
            className={`alert ${alert.alertType}`}
            role={alert.alertType === "failure" ? "alert" : "status"}
            aria-live="polite"
          >
            <span dangerouslySetInnerHTML={{ __html: alert.message }} />
            <button
              className="alert-dismiss"
              onClick={() => removeAlert(alert.id)}
              aria-label="Dismiss alert"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </StickyDiv>
  );
};

const mapStateToProps = (state) => ({
  alerts: state.alerts,
});

export default connect(mapStateToProps, { removeAlert })(Alert);
